import {
  ChakraFlex,
  FAIconName,
  FireflyButton,
  Icon,
  Text,
} from '@equip.health/ui';

import {
  MAI_CHAT_HISTORY_ERROR,
  MAI_CHAT_RETRY_CTA,
} from './maiChat.constants';

const TOP_LEVEL_ID = 'mai-chat-history-error';

interface MaiChatHistoryNoticeProps {
  onRetry: () => void;
}

const MaiChatHistoryNotice = ({ onRetry }: MaiChatHistoryNoticeProps) => (
  <ChakraFlex
    data-testid={TOP_LEVEL_ID}
    role="alert"
    alignItems="center"
    gap="10px"
    padding="10px 12px"
    borderRadius="10px"
    background="error.background"
    border="1px solid"
    borderColor="error.line"
  >
    <Icon
      name={FAIconName.exclamationCircleRegular}
      color="error.primary"
      size="sm"
    />
    <Text color="neutral.primary" flex="1" variant="caption">
      {MAI_CHAT_HISTORY_ERROR}
    </Text>
    <FireflyButton
      id={`${TOP_LEVEL_ID}__retry`}
      onClick={onRetry}
      size="small"
      variant="tertiary"
    >
      {MAI_CHAT_RETRY_CTA}
    </FireflyButton>
  </ChakraFlex>
);

export default MaiChatHistoryNotice;
